import { FULL_HD, HD, IMAGE_FIT_MAX, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../utils/sizes';

export * from './customer/default/jumbotron.constants';

export const Z_INDEX_NORMAL = 0;

export const Z_INDEX_WITH_PROGRAM_INFO = 1000;

export const templates = {
  Jumbotron: 'Jumbotron',
};

export const HIGHLIGHT_SEPARATOR = ' | ';

export const sizes = {
  [templates.Jumbotron]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        w: SCREEN_WIDTH[HD],
        h: SCREEN_HEIGHT[HD],
      },
      [FULL_HD]: {
        w: SCREEN_WIDTH[FULL_HD],
        h: SCREEN_HEIGHT[FULL_HD],
      },
    },
  },
};

export const LOGO_DIMENSIONS = {
  [HD]: {
    width: 299,
    height: 168,
  },
  [FULL_HD]: {
    width: 597,
    height: 336,
  },
};

export const imageOptions = {
  [templates.Jumbotron]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          width: sizes[templates.Jumbotron][RENDERING_CONTEXT.GENERAL][HD].w,
          height: sizes[templates.Jumbotron][RENDERING_CONTEXT.GENERAL][HD].h,
        },
        SECONDARY: {
          width: SCREEN_WIDTH[HD],
          height: SCREEN_HEIGHT[HD],
        },
        LOGO: {
          ...LOGO_DIMENSIONS[HD],
          fit: IMAGE_FIT_MAX,
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          width: sizes[templates.Jumbotron][RENDERING_CONTEXT.GENERAL][FULL_HD].w,
          height: sizes[templates.Jumbotron][RENDERING_CONTEXT.GENERAL][FULL_HD].h,
        },
        SECONDARY: {
          width: SCREEN_WIDTH[FULL_HD],
          height: SCREEN_HEIGHT[FULL_HD],
        },
        LOGO: {
          ...LOGO_DIMENSIONS[FULL_HD],
          fit: IMAGE_FIT_MAX,
        },
      },
    },
  },
};
